import React, { cloneElement } from 'react';
import { Link } from 'components/link/Link';

import s from './PartnersGridItem.scss';


interface IProps {
  image: React.ReactElement;
  link?: string;
}

export const PartnersGridItem = ({ image, link }: IProps) => {

  return (
    <div className={s.partnersGridItem}>
        <div className={s.partnersGridItem__inner}>
          <div className={s.partnersGridItem__imageWrap}>
            {cloneElement(image, {
              className: s.partnersGridItem__image,
              transparent: true,
            })}
          </div>
        </div>
        {link && <Link className={s.partnersGridItem__link} to={link}></Link>}
    </div>
  );
};
